/* Directional icons are drawn for right-to-left pages; flip them in left-to-right ones. */
:global([dir='ltr']) .mirror {
  transform: scaleX(-1);
}
